import styled from "@emotion/styled";
import { PRIMARY_BLACK } from "src/constants/colors";

export const Container = styled.div<{ isOpened: boolean }>`
  background-color: ${({ isOpened }) =>
    isOpened ? "rgb(255,255,255)" : "rgba(243, 245, 248, 1)"};
  border-radius: 8px;
  border: ${({ isOpened }) =>
    isOpened ? "1px solid rgba(228, 231, 236, 1);" : 0};
  padding: 16px;
`;

export const HeaderContainer = styled.div<{
  showTasks: boolean;
  isAppDrivenStatus: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: ${({ showTasks, isAppDrivenStatus }) =>
    showTasks && !isAppDrivenStatus ? "pointer" : "default"};
`;

export const HeaderTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const HeaderActionContainer = styled.div<{
  showTasks: boolean;
  isAppDrivenStatus: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding-right: ${({ showTasks, isAppDrivenStatus }) =>
    showTasks && !isAppDrivenStatus ? "0" : "25px"};
`;

export const StatusIcon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 18px;
  min-height: 18px;
  width: 18px;
  min-width: 18px;

  & * {
    height: 100%;
    width: 100%;
  }
`;

export const IndexLabel = styled.div`
  color: rgba(74, 84, 102, 1);
  font-size: 16px;
`;

export const TitleLabel = styled.div<{ isOpened: boolean; status: string }>`
  color: ${({ isOpened }) =>
    isOpened ? PRIMARY_BLACK : "rgba(74, 84, 102, 1)"};
  font-size: 16px;
  font-weight: 600;
  margin: 0px 5px;
  text-decoration: ${({ status }) =>
    status === "Completed" ? "line-through 2px" : "none"};
`;
